<template>
  <h1 class="text-2xl font-bold text-green-600 mb-2 text-center">Step not found</h1>

  <div class="text-center">
    <RouterLink class="text-xl font-semibold text-gray-800 mb-1" to="/quiz">Restart the quiz</RouterLink>
  </div>
</template>